import { render, staticRenderFns } from "./embed_dashboards.vue?vue&type=template&id=11edbf0c&scoped=true"
import script from "./embed_dashboards.vue?vue&type=script&lang=js"
export * from "./embed_dashboards.vue?vue&type=script&lang=js"
import style0 from "./embed_dashboards.vue?vue&type=style&index=0&id=11edbf0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11edbf0c",
  null
  
)

export default component.exports